var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import * as ReactDOM from 'react-dom';
import { defaultProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import { atomicMapSlider } from './atomicMap';
import Handler from './Handler';
import Track from './Track';
import { noop } from '../../Utils/function';
import { addEventListenerWrap } from '../../Utils/react';
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        _this.sliderRef = React.createRef();
        _this.newStep = 1;
        _this.handleIndex = 0;
        _this.handleRefIndex = 0;
        _this.move = null;
        _this.up = null;
        _this.contextmenu = null;
        _this.onDragStart = function (e) {
            var _a, _b, _c, _d, _e, _f;
            var currValue = _this.state.currValue;
            var _g = _this.props, direction = _g.direction, range = _g.range, reverse = _g.reverse;
            var width = ((_a = _this.sliderRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
            var height = ((_b = _this.sliderRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
            var left = ((_c = _this.sliderRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().left) || 0;
            var top = ((_d = _this.sliderRef.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect().top) || 0;
            var right = ((_e = _this.sliderRef.current) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect().right) || 0;
            var bottom = ((_f = _this.sliderRef.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect().bottom) || 0;
            var clientY = e.clientY;
            var clientX = e.clientX;
            _this.setState({ dragging: true, tipVisible: true });
            //每次点击重置 点击的hanle
            var diff = _this.calcDiff(direction, reverse, clientX, clientY, width, height, top, left, bottom, right);
            if (diff == currValue)
                return;
            //slide
            //计算step
            var curStep = _this.calcStep(diff);
            // 当 curStep 为整数时且等于自身时
            if (Math.round(curStep) >= Math.floor(curStep)) {
                diff = Math.round(curStep) * _this.newStep;
                //range
                if (range) {
                    var value = __spread(currValue);
                    //点击时 获取离点击点最近的handle移动
                    _this.handleRefIndex = _this.calcNearHandle(diff);
                    value[_this.handleRefIndex] = diff;
                    _this.setState({
                        currValue: value,
                    }, function () {
                        _this.handleChange();
                    });
                }
                else {
                    _this.setState({
                        currValue: diff,
                    }, function () {
                        _this.handleChange();
                    });
                }
            }
        };
        _this.onDragging = function (e) {
            var _a, _b, _c, _d, _e, _f;
            var _g = _this.state, dragging = _g.dragging, currValue = _g.currValue;
            var _h = _this.props, direction = _h.direction, range = _h.range, reverse = _h.reverse;
            var width = ((_a = _this.sliderRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
            var height = ((_b = _this.sliderRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
            var left = ((_c = _this.sliderRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().left) || 0;
            var top = ((_d = _this.sliderRef.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect().top) || 0;
            var right = ((_e = _this.sliderRef.current) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect().right) || 0;
            var bottom = ((_f = _this.sliderRef.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect().bottom) || 0;
            var clientY = e.clientY;
            var clientX = e.clientX;
            if (dragging) {
                var diff = _this.calcDiff(direction, reverse, clientX, clientY, width, height, top, left, bottom, right);
                if (diff == currValue)
                    return;
                //计算step
                var curStep = _this.calcStep(diff);
                // 当 curStep 为整数时且等于自身时
                if (Math.round(curStep) >= Math.floor(curStep)) {
                    diff = Math.round(curStep) * _this.newStep;
                    if (range) {
                        var value = __spread(currValue);
                        var handleRefIndex = _this.handleRefIndex;
                        value[handleRefIndex] = diff;
                        _this.setState({
                            currValue: value,
                        }, function () {
                            _this.handleChange();
                        });
                    }
                    else {
                        _this.setState({
                            currValue: diff,
                        }, function () {
                            _this.handleChange();
                        });
                    }
                }
            }
        };
        _this.onDragEnd = function (ev) {
            var dragging = _this.state.dragging;
            var target = ev.target;
            if (dragging) {
                var slider = ReactDOM.findDOMNode(_this.sliderRef.current);
                if (slider && !slider.contains(target)) {
                    _this.setState({ tipVisible: false });
                }
                _this.setState({ dragging: false }, function () {
                    var _a, _b, _c;
                    (_a = _this.move) === null || _a === void 0 ? void 0 : _a.remove();
                    (_b = _this.up) === null || _b === void 0 ? void 0 : _b.remove();
                    (_c = _this.contextmenu) === null || _c === void 0 ? void 0 : _c.remove();
                });
            }
        };
        _this.handler = function () {
            var _a = _this.props, range = _a.range, disabled = _a.disabled, onBeforeChange = _a.onBeforeChange, rest = __rest(_a, ["range", "disabled", "onBeforeChange"]);
            var _b = _this.state, currValue = _b.currValue, tipVisible = _b.tipVisible;
            if (range) {
                return (React.createElement(React.Fragment, null, currValue.map(function (v, index) {
                    return (React.createElement(Handler, __assign({}, rest, { value: _this.formatValue(v), offset: v, index: index, visible: tipVisible, showLabel: true, key: "handle" + index })));
                })));
            }
            return (React.createElement(Handler, __assign({}, rest, { visible: tipVisible, showLabel: true, value: _this.formatValue(currValue), offset: currValue })));
        };
        _this.track = function () {
            var currValue = _this.state.currValue;
            var _a = _this.props, range = _a.range, marks = _a.marks, rest = __rest(_a, ["range", "marks"]);
            var tmp;
            var length;
            var value;
            if (range) {
                tmp = __spread(currValue);
                value = Math.min(tmp[0], tmp[1]);
                length = Math.max(tmp[0], tmp[1]) - Math.min(tmp[0], tmp[1]);
            }
            else {
                tmp = currValue;
                value = 0;
                length = tmp;
            }
            return React.createElement(Track, __assign({ length: length, offset: value, marks: marks }, rest));
        };
        _this.handleChange = function () {
            var _a = _this.props, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange;
            var fv = _this.formatValue(_this.state.currValue);
            if (onBeforeChange(fv)) {
                onChange(fv);
            }
        };
        _this.handleMouseDown = function (e) {
            var disabled = _this.props.disabled;
            if (disabled)
                return;
            _this.setState({ tipVisible: true });
            e.preventDefault();
            _this.onDragStart(e);
            _this.move = addEventListenerWrap(window, 'mousemove', _this.onDragging);
            _this.up = addEventListenerWrap(window, 'mouseup', _this.onDragEnd);
            _this.contextmenu = addEventListenerWrap(window, 'contextmenu', _this.onDragEnd);
        };
        _this.focus = function () {
            _this.setState({ tipVisible: true });
        };
        var dfv = props.defaultValue;
        dfv < props.min && (dfv = props.min);
        dfv > props.max && (dfv = props.max);
        if (dfv < props.min || dfv > props.max) {
            console.warn('默认值设置超出范围');
        }
        _this.state = {
            currValue: _this.initValue(_this.calcDefaultValue(props.defaultValue)),
            dragging: false,
            tipVisible: true,
        };
        _this.newStep = (100 / (props.max - props.min)) * props.step;
        return _this;
    }
    Slider.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.value) {
            this.setState({
                currValue: this.initValue(this.calcDefaultValue(nextProps.defaultValue)),
            });
        }
    };
    Slider.prototype.calcDefaultValue = function (val) {
        var min = this.props.min;
        if (Array.isArray(val)) {
            return [val[0] - min, val[1] - min];
        }
        else {
            return val - min;
        }
    };
    Slider.prototype.initValue = function (val) {
        var _a = this.props, max = _a.max, min = _a.min, range = _a.range;
        if (!val)
            !range ? 0 : [0, 0];
        if (typeof val === 'number') {
            return (val / (max - min)) * 100;
        }
        else {
            return val.map(function (v) { return (v / (max - min)) * 100; });
        }
    };
    Slider.prototype.calcDiff = function (direction, reverse, clientX, clientY, width, height, top, left, bottom, right) {
        var diff = 0;
        if (direction) {
            diff = reverse ? ((clientY - top) / height) * 100 : ((bottom - clientY) / height) * 100;
        }
        else {
            diff = reverse ? ((right - clientX) / width) * 100 : ((clientX - left) / width) * 100;
        }
        diff = Math.min(diff, 100);
        diff = Math.max(0, diff);
        return diff;
    };
    Slider.prototype.calcStep = function (val) {
        //计算step 和 max min之间的关系
        var step = this.newStep;
        var maxSteps = Math.floor(100 / step);
        var steps = Math.min(val / step, maxSteps);
        return steps;
    };
    Slider.prototype.getValue = function () {
        return this.state.currValue;
    };
    Slider.prototype.calcNearHandle = function (val) {
        var currValue = this.state.currValue;
        var value = __spread(currValue);
        var tmpMin = Math.min(value[0], value[1]);
        var tmpMax = Math.max(value[0], value[1]);
        var minIndex = value.indexOf(tmpMin);
        var maxIndex = value.indexOf(tmpMax);
        if (val <= tmpMin)
            return minIndex;
        if (val >= tmpMax)
            return maxIndex;
        if (Math.max(tmpMin, val) == Math.min(val, tmpMax)) {
            if (val - tmpMin >= tmpMax - val) {
                return maxIndex;
            }
            else {
                return minIndex;
            }
        }
        return this.handleIndex;
    };
    Slider.prototype.formatValue = function (val) {
        return Math.floor((val / this.newStep) * this.props.step + this.props.min);
    };
    Slider.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, style = _a.style, className = _a.className, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange, range = _a.range, direction = _a.direction, reverse = _a.reverse, rest = __rest(_a, ["disabled", "style", "className", "onChange", "onBeforeChange", "range", "direction", "reverse"]);
        if (direction) {
            atomicMapSlider.vSlider = [
                'relative',
                'w-px-12',
                'cursor-pointer',
                'box-border',
                'px-px-4',
                'h-full',
            ];
            atomicMapSlider.vRail = ['absolute', 'w-px-8', 'rounded-md', 'h-full'];
        }
        return (React.createElement(DivTag, __assign({}, rest, { name: Slider.NAME, atomics: direction ? atomicMapSlider.vSlider : atomicMapSlider.slider, onMouseDown: disabled ? noop : this.handleMouseDown, ref: this.sliderRef, style: style, className: className }),
            React.createElement(DivTag, { atomics: direction ? atomicMapSlider.vRail : atomicMapSlider.rail, style: {
                    background: 'rgba(0,0,0,0.04)',
                    borderRadius: '4px',
                    boxShadow: 'inset 0px 1px 2px 0px rgba(0,0,0,0.09)',
                } }),
            this.track(),
            this.handler()));
    };
    Slider.defaultProps = defaultProps;
    Slider.NAME = 'slider';
    Slider.displayName = 'Slider';
    return Slider;
}(PureComponent));
export { Slider };
